import { render, staticRenderFns } from "./AddCourse.vue?vue&type=template&id=2e2d86f6&"
import script from "./AddCourse.vue?vue&type=script&lang=js&"
export * from "./AddCourse.vue?vue&type=script&lang=js&"
import style0 from "./AddCourse.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports